import { TradeMethodFilesValidationPage } from 'features/trade-methods';

export const TechOperatorTradeMethodFilesValidationPage: React.FC = () => (
  <TradeMethodFilesValidationPage />
);
